import {FC} from 'react';

import {Box, Stack, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import {TypeLocation} from '../../shared/types/menu.types';

interface INotFoundErrorInsideComponent {
  to: TypeLocation;
}

const NotFoundErrorInsideComponent: FC<INotFoundErrorInsideComponent> = ({to}) => {
  return (
    <Box
      sx={{
        width: 'calc(100% - 32px)',
        height: 'calc(100% - 48px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
      }}
    >
      <Stack direction="column" spacing={4} sx={{alignItems: 'center'}}>
        <Stack direction="column" sx={{textAlign: 'center'}} spacing={3}>
          <Typography variant="h6">Извините, ничего не найдено</Typography>
          <Typography variant="h4">404</Typography>
        </Stack>
        <Link to={to}>
          <Typography variant="h6">Вернуться назад</Typography>
        </Link>
      </Stack>
    </Box>
  );
};

export default NotFoundErrorInsideComponent;
